import { useEffect, useState } from "react";
// This support list is maintained manually, we can expand it as more roles and elements become available in browsers
// and tested with various assistive tech
const supportedAriaRoles = ["link", "button", "textbox", "checkbox", "radio", "combobox", "option", "menuitem"];
const supportedHtmlTags = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"];
function isAriaDescriptionSupported(ref) {
    if (!ref.current) {
        return false;
    }
    if (ref.current.hasAttribute("role")) {
        return supportedAriaRoles.includes(ref.current.getAttribute("role"));
    }
    return supportedHtmlTags.includes(ref.current.tagName);
}
export function useIsAriaDescriptionSupported(triggerRef) {
    // eslint-disable-next-line react/hook-use-state -- state isn't used, only needed to force a re-render
    const [, setOptimisticRenderFailed] = useState(false);
    const descriptionSupported = triggerRef
        ? !triggerRef.current || // render optimistically
            isAriaDescriptionSupported(triggerRef)
        : false; // only uses targetElement to position itself
    useEffect(() => {
        // In the rare event that we have rendered tooltip contents and aria-describedby but the element doesn't actually support it
        if (triggerRef?.current && descriptionSupported && !isAriaDescriptionSupported(triggerRef)) {
            setOptimisticRenderFailed(true);
        }
    }, [triggerRef, descriptionSupported]);
    return descriptionSupported;
}
